import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import view from "../Images/360.jpg";
import SEO from "../components/SEO";  

export default function ThreeSixtyDegreeView() {
  return (
    <>
      <SEO  
        title="360-Degree Customer View in AI CRM | EnteliPro"
        description="Get a complete 360-degree view of your customers with EnteliPro AI CRM. Track interactions, preferences, purchase history, and engagement across all touchpoints."
        keywords="360 Degree Customer View, AI CRM Software, Customer 360 View, Customer Insights, Customer Engagement Platform, Omnichannel CRM"
        canonical="https://www.entelipro.com/360degreeview"
        ogImage="https://www.entelipro.com/static/media/360view.jpg"
      />

      <Navbar />
      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">360-Degree Customer View</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={view}
                  alt="EnteliPro 360-Degree Customer View in AI CRM Software"
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}>
                  360-Degree Customer View in AI CRM
                </h1>
                <p className="para">
                  A 360-degree customer view is a comprehensive approach to understanding
                  your customers by consolidating data from every interaction across all
                  touchpoints. EnteliPro AI CRM provides a unified dashboard that gives
                  you complete visibility into customer behavior, preferences, and needs.
                </p>
                <div className="jst-two-coloums mt-4">
                  <div className="icon-text">
                    <p className="para">
                      With a 360-degree view, your sales and support teams can deliver
                      personalized experiences, anticipate customer needs, and build
                      stronger relationships that drive loyalty and revenue growth.
                    </p>
                  </div>
                  <div className="icon-text mt-lx-3 pt-lx-1">
                    <p className="para">
                      EnteliPro integrates data from sales, marketing, support, and
                      social channels to create a complete customer profile that enables
                      data-driven decision-making across your organization.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>Why 360-Degree Customer View Matters</h3>
              <p className="para">
                In today's competitive business environment, understanding your customers
                is essential for success. A 360-degree view helps you identify cross-sell
                and up-sell opportunities, improve customer satisfaction, and reduce churn
                by delivering exactly what your customers need when they need it.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-features-4">
        <div className="features4-block">
          <div className="container">
            <div className="main-titles-head text-center">
              <h3 className="header-name">
                Key Features of 360-Degree Customer View
              </h3>
            </div>
            <div className="features-effect row text-center">
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6">
                <div className="back-color">
                  <h4>Unified Customer Profiles</h4>
                  <p className="para">
                    Consolidate all customer data from sales, marketing, support, and
                    social media into a single, unified profile for complete visibility.
                  </p>
                </div>
              </div>
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6">
                <div className="back-color">
                  <h4>Interaction History Tracking</h4>
                  <p className="para">
                    Track every customer interaction across email, phone, chat, social
                    media, and in-person meetings to understand engagement patterns.
                  </p>
                </div>
              </div>
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6">
                <div className="back-color">
                  <h4>Predictive Customer Insights</h4>
                  <p className="para">
                    Leverage AI-powered analytics to predict customer behavior, identify
                    churn risks, and uncover cross-sell opportunities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}